<template>
  <div :class="playNowClass" >
    <a href="#" @click.prevent="goDetail(cellInfo)">
      <div class="thumb-image">
        <img v-lazy="getLazyLoadingImageObject()" class="thumb-img" :alt="altTitle"/>
        <div v-if="hasProgress" class="cell-progress">
          <span class="gradation-purple" :style="'width:' + Number(progress) * 100 + '%;'"></span>
        </div>
        <div class="tag-top tag-list" v-top-tag-list="topTagList"></div>
        <div class="tag-bottom tag-list" v-if="!isAdultContent && hasBottomTagList" v-bottom-tag-list="bottomTagList"></div>
        <div class="tag-bottom-time" v-if="hasTimeTag">
          <i class="tag-time">{{cellInfo.time}}</i>
        </div>
        <age-limits :target-age="targetAge" :age-tag="ageTag"/>
        <div :class="adultDimClass"></div>
      </div>

      <div class="sub-title">
        <!-- PC 는 Rank를 표시하지 않는다 -->
<!--        <div v-if="hasRank" class="sub-left">-->
<!--          <div class="num">{{ rank }}</div>-->
<!--        </div>-->
        <div class="sub-right" ref="title"
             v-title-list="{'titleList': cellInfo.title_list,
                            'searchWord': searchWord,
                            'cellType': 'landscape',
                            'callback': loaded
                            }">
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import _ from 'lodash'
import AgeLimits from '@/components/model/AgeLimits'
import shave from 'shave'
import { bottomTagList, titleList, topTagList } from '@/common/resources/directives'
import CellMixIn from '@/mixins/cell.mixin'
import fp from 'lodash/fp'
import { getCellEventObject } from '@/common/utils/gnb.fp'
export default {
  mixins: [
    CellMixIn
  ],
  directives: {
    titleList,
    topTagList,
    bottomTagList
  },
  components: {
    AgeLimits
  },
  props: {
    cellInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    },
    searchWord: {
      type: String
    }
  },
  computed: {
    hasTimeTag () {
      return _.get(this.cellInfo, 'time', '') !== ''
    },
    playNowClass () {
      const nowChannelId = _.get(this.$route, ['query', 'channelid'], '')
      const { onNavigation } = fp.flow(fp.get('event_list'), getCellEventObject)(this.cellInfo)
      const url = _.get(onNavigation, 'url', '')
      const contentId = url.split('=').pop()
      return nowChannelId !== '' && nowChannelId === contentId ? 'thumb landscape playnow' : 'thumb landscape'
    },
    altTitle () {
      let title = ''
      _.get(this.cellInfo, 'title_list', []).forEach((titleItem) => {
        title += ' ' + titleItem.text
      })
      return title
    }
  },
  methods: {
    loaded (el) {
      this.$nextTick(() => {
        _.forEach(el.querySelectorAll('.line1'), (line1El) => {
          shave(line1El, 28)
        })
      })
    }
  }
}
</script>

<style lang="css">
  .landscape{
    width: 240px;
    position: relative;
    margin-right: 10px;
    float: left;
  }

  .landscape .thumb-image{
    position: relative;
    height: 135px;
    width: 240px;
    overflow: hidden;
    border: 1px solid rgba(168, 168, 168, .15);
    -webkit-background-clip: padding-box; /* for Safari */
    background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */
    will-change: transform;
    transform: translateZ(0);
  }

  .landscape .thumb-image .thumb-img{
    width: 100%;
  }

  .cell-progress{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: rgba(0, 0, 0, .2);
  }

  .cell-progress span{
    display: block;
    width: 100%;
    height: 4px;
  }
  .week6 {
    font-size: 14px;
    line-height: 22px;
    color: #1351f9;
  }

  .list-view-detail .live-ui .landscape{
    float: none;
    display: inline-block;
    margin-bottom: 0;
    vertical-align: top;
  }

</style>

<style lang="css" scoped>
  .multi .swiper-slide span.creator-name {
    margin:-2px 0 0;
  }
</style>
